/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const CartMessage = {
  deliveryCost: (freeDeliveryThreshold: number) =>
    `Delivery costs will be determined and confirmed during order processing. Free delivery for orders over $${freeDeliveryThreshold} GST excl.`,
  deliveryCostExcluded: "Delivery cost excluded",
  chargedToAccount: "This order will be charged to your account once it has been fulfilled.",
  deliceryCostAdjustableTitle: "Changes to delivery cost",
  deliveryCostAdjustable:
    "Adjustments to the products or quantity ordered may change the final delivery fee, any changes will be confirmed during processing.",
};
